/**
 * @typedef {import('antd').PopoverProps} PopoverProps
 */
import React from 'react';

import { Popover as PopoverCore } from 'antd';

/**
 * @description UI Component to display the popover element. Underlying it is using the antd popover component.
 *
 * @author  Akshay Jain <@akshay.jain2>
 *
 * @reference https://ant.design/components/popover
 *
 * @param {PopoverProps}  props https://ant.design/components/popover
 *
 * @returns {React.component}
 */

const Popover = (props) => {
	const {
		children,
		trigger = 'click',
		placement = 'bottomRight',
		...restProps
	} = props;

	return (
		<PopoverCore trigger={trigger} placement={placement} {...restProps}>
			{children}
		</PopoverCore>
	);
};

export default Popover;
